export default {
	"type": "form",
	"tags": [],
	"owner": "5b880606acd5b553f1ad58ea",
	"components": [
		{
			"autofocus": false,
			"input": true,
			"tableView": true,
			"inputType": "text",
			"inputMask": "",
			"label": "Message Title",
			"key": "messageTitle",
			"placeholder": "",
			"prefix": "",
			"suffix": "",
			"multiple": false,
			"defaultValue": "",
			"protected": false,
			"unique": false,
			"persistent": true,
			"hidden": false,
			"clearOnHide": true,
			"spellcheck": true,
			"validate": {
				"required": true,
				"minLength": "",
				"maxLength": "",
				"pattern": "",
				"custom": "",
				"customPrivate": false
			},
			"conditional": {
				"show": "",
				"when": null,
				"eq": ""
			},
			"type": "textfield",
			"labelPosition": "top",
			"inputFormat": "plain",
			"tags": [],
			"properties": {}
		},
		{
			"autofocus": false,
			"input": true,
			"tableView": true,
			"label": "Content",
			"key": "messageContent",
			"placeholder": "",
			"prefix": "",
			"suffix": "",
			"rows": 3,
			"multiple": false,
			"defaultValue": "",
			"protected": false,
			"persistent": true,
			"hidden": false,
			"wysiwyg": true,
			"clearOnHide": true,
			"spellcheck": true,
			"validate": {
				"required": true,
				"minLength": "",
				"maxLength": "",
				"pattern": "",
				"custom": ""
			},
			"type": "textarea",
			"labelPosition": "top",
			"inputFormat": "html",
			"tags": [],
			"conditional": {
				"show": "",
				"when": null,
				"eq": ""
			},
			"properties": {},
			"lockKey": true,
			"isNew": false
		},
		{
			"autofocus": false,
			"input": true,
			"tableView": true,
			"label": "Publish Date",
			"key": "publishDate",
			"placeholder": "",
			"format": "yyyy-MM-dd hh:mm a",
			"enableDate": true,
			"enableTime": true,
			"defaultDate": "",
			"datepickerMode": "day",
			"datePicker": {
				"showWeeks": true,
				"startingDay": 0,
				"initDate": "",
				"minMode": "day",
				"maxMode": "year",
				"yearRows": 4,
				"yearColumns": 5,
				"minDate": null,
				"maxDate": null,
				"datepickerMode": "day"
			},
			"timePicker": {
				"hourStep": 1,
				"minuteStep": 1,
				"showMeridian": true,
				"readonlyInput": false,
				"mousewheel": true,
				"arrowkeys": true
			},
			"protected": false,
			"persistent": true,
			"hidden": false,
			"clearOnHide": true,
			"validate": {
				"required": true,
				"custom": ""
			},
			"type": "datetime",
			"labelPosition": "top",
			"tags": [],
			"conditional": {
				"show": "",
				"when": null,
				"eq": ""
			},
			"properties": {}
		},
		{
			"autofocus": false,
			"input": true,
			"tableView": true,
			"label": "Expiration Date",
			"key": "expirationDate",
			"placeholder": "",
			"format": "yyyy-MM-dd hh:mm a",
			"enableDate": true,
			"enableTime": true,
			"defaultDate": "moment().add(30, 'days');",
			"datepickerMode": "day",
			"datePicker": {
				"showWeeks": true,
				"startingDay": 0,
				"initDate": "",
				"minMode": "day",
				"maxMode": "year",
				"yearRows": 4,
				"yearColumns": 5,
				"minDate": null,
				"maxDate": null,
				"datepickerMode": "day"
			},
			"timePicker": {
				"hourStep": 1,
				"minuteStep": 1,
				"showMeridian": true,
				"readonlyInput": false,
				"mousewheel": true,
				"arrowkeys": true
			},
			"protected": false,
			"persistent": true,
			"hidden": false,
			"clearOnHide": true,
			"validate": {
				"required": true,
				"custom": ""
			},
			"type": "datetime",
			"labelPosition": "top",
			"tags": [],
			"conditional": {
				"show": "",
				"when": null,
				"eq": ""
			},
			"properties": {}
		},
		{
			"clearOnHide": false,
			"key": "panel",
			"input": false,
			"title": "Target Roles",
			"theme": "default",
			"tableView": false,
			"components": [
				{
					"autofocus": false,
					"input": true,
					"inputType": "checkbox",
					"tableView": true,
					"label": "Executives",
					"dataGridLabel": false,
					"key": "panelExecutives",
					"defaultValue": false,
					"protected": false,
					"persistent": true,
					"hidden": false,
					"name": "",
					"value": "",
					"clearOnHide": true,
					"validate": {
						"required": false
					},
					"type": "checkbox",
					"labelPosition": "right",
					"hideLabel": false,
					"tags": [],
					"conditional": {
						"show": "",
						"when": null,
						"eq": ""
					},
					"properties": {}
				},
				{
					"autofocus": false,
					"input": true,
					"inputType": "checkbox",
					"tableView": true,
					"label": "Sales Manager",
					"dataGridLabel": false,
					"key": "panelSalesManager",
					"defaultValue": false,
					"protected": false,
					"persistent": true,
					"hidden": false,
					"name": "",
					"value": "",
					"clearOnHide": true,
					"validate": {
						"required": false
					},
					"type": "checkbox",
					"labelPosition": "right",
					"hideLabel": false,
					"tags": [],
					"conditional": {
						"show": "",
						"when": null,
						"eq": ""
					},
					"properties": {}
				},
				{
					"autofocus": false,
					"input": true,
					"inputType": "checkbox",
					"tableView": true,
					"label": "Sales Rep",
					"dataGridLabel": false,
					"key": "panelSalesRep",
					"defaultValue": false,
					"protected": false,
					"persistent": true,
					"hidden": false,
					"name": "",
					"value": "",
					"clearOnHide": true,
					"validate": {
						"required": false
					},
					"type": "checkbox",
					"labelPosition": "right",
					"hideLabel": false,
					"tags": [],
					"conditional": {
						"show": "",
						"when": null,
						"eq": ""
					},
					"properties": {}
				},
				{
					"autofocus": false,
					"input": true,
					"inputType": "checkbox",
					"tableView": true,
					"label": "Retailer",
					"dataGridLabel": false,
					"key": "panelRetailer",
					"defaultValue": false,
					"protected": false,
					"persistent": true,
					"hidden": false,
					"name": "",
					"value": "",
					"clearOnHide": true,
					"validate": {
						"required": false
					},
					"type": "checkbox",
					"labelPosition": "right",
					"tags": [],
					"conditional": {
						"show": "",
						"when": null,
						"eq": ""
					},
					"properties": {},
					"hideLabel": false,
					"lockKey": true
				}
			],
			"type": "panel",
			"breadcrumb": "default",
			"hideLabel": false,
			"tags": [],
			"conditional": {
				"show": "",
				"when": null,
				"eq": ""
			},
			"properties": {}
		},
		{
			"autofocus": false,
			"input": true,
			"label": "Submit",
			"tableView": false,
			"key": "submit",
			"size": "md",
			"leftIcon": "",
			"rightIcon": "",
			"block": false,
			"action": "submit",
			"disableOnInvalid": false,
			"theme": "primary",
			"type": "button"
		}
	],
	"revisions": "",
	"_vid": 0,
	"_id": "5b8807e7acd5b55711ad5945",
	"title": "Corporate Message",
	"display": "form",
	"access": [
		{
			"roles": [
				"5b88072cacd5b53313ad5918",
				"5b88072cacd5b5f747ad5919",
				"5b88072cacd5b55293ad591a"
			],
			"type": "read_all"
		}
	],
	"submissionAccess": [],
	"settings": {},
	"name": "corporateMessage",
	"path": "corporatemessage",
	"project": "5b88072cacd5b53c66ad5917",
	"created": "2018-08-30T15:06:15.377Z",
	"modified": "2018-08-31T20:34:06.522Z",
	"machineName": "irlxqknnoqiregk:corporateMessage"
}